















































































































































































































import {Component, Mixins} from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import XForm from "@/components/SimpleForm.vue";
import ButtonWithMessage from "./ButtonWithMessage.vue";
import { techSupportForm } from "@/assets/scripts/form-fields/main";
import AppApiMixin from "../mixins/AppApi.vue";
import VueRecaptcha from 'vue-recaptcha';
import XNotice from "@/components/hoc/SimpleNotice.vue";
import DocGetterCard
  from "@/components/for-turnovers-and-reports-view/DocGetterCard.vue";
import DocGetterDialog
  from "@/components/for-turnovers-and-reports-view/DocGetterDialog.vue";
import {AxiosResponse} from "axios";
import DocGetterMixin from "@/components/mixins/DocGetter.vue";
import {mapGetters} from "vuex";
import FileInputMixin from "@/components/mixins/FileInputMixin.vue";

const { values, attrs, validations, errors } = techSupportForm;

@Component({
  components: {
    DocGetterDialog,
    DocGetterCard,
    XNotice,
    XForm,
    ButtonWithMessage,
    VueRecaptcha
  },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapGetters({
      branchesList: "branches/branchesList",
      branchesListFormatted: "branches/branchesListFormatted",
    }),
    showAgreementCalc() {
      return this.branchID == 'SCS';
    },
  },
  validations,
})
class TechnicalSupport extends Mixins(AppApiMixin, XForm, DocGetterMixin, FileInputMixin) {
  [x: string]: any;

  // Используем оригинальные values (без изменений)
  values = {
    ...values,
    file: "" // Оставляем как строку для формы, но не используем
  };

  // File handling properties
  selectedFiles: File[] = []; // Для v-file-input
  fileList: File[] = []; // Основной список файлов
  fileError: string = "";
  filesValid: boolean = true;

  useSubmitButtonLoading = false;
  submitError = "";
  submitSuccess = "";
  hasFileErrors = false;

  siteKey = "";
  recaptchaEnabled = false;

  get branchID() {
    return this.branchesList.filter(_ => _.full_name == this.values['branch']).map(_ => _.name)[0] || "";
  }

  // Форма без поля file
  get allFieldAttrsWithoutFile() {
    const { file, ...otherAttrs } = attrs;
    return otherAttrs;
  }

  // Полные аттрибуты (для совместимости)
  get allFieldAttrs() {
    return this.allFieldAttrsWithoutFile;
  }

  // Переопределяем textFields в SimpleForm
  get textFields() {
    return this.allFieldAttrsWithoutFile;
  }

  // метод для безопасного вызова $touch()
  touchField(fieldName: string) {
    if (this.$v.values && this.$v.values[fieldName]) {
      this.$v.values[fieldName].$touch();
    }
  }

  // Get errors (skip file field)
  getErrors(fieldName: string) {
    if (fieldName === 'file') return [];
    return this[`${fieldName}Errors`] || [];
  }

  /**
   * Обработчик изменения файлов в поле ввода
   */
  handleFileInputChange(files: File | File[] | null) {
    if (!files) {
      return;
    }

    // Преобразуем в массив, если это не массив
    const filesArray = Array.isArray(files) ? files : [files];

    // Добавляем файлы к существующим
    const existingFileNames = this.fileList.map(f => f.name);
    const uniqueNewFiles = filesArray.filter(file =>
      !existingFileNames.includes(file.name)
    );

    if (uniqueNewFiles.length > 0) {
      this.fileList = [...this.fileList, ...uniqueNewFiles];
      this.validateFiles();
    }

    // Очищаем поле ввода (чтобы можно было выбрать те же файлы снова)
    this.selectedFiles = [];
  }

  /**
   * Добавление новых файлов (альтернативный метод)
   */
  onFilesAdded(files: File[]) {
    if (files && files.length > 0) {
      const existingFileNames = this.fileList.map(f => f.name);
      const uniqueNewFiles = files.filter(file =>
        !existingFileNames.includes(file.name)
      );

      if (uniqueNewFiles.length > 0) {
        this.fileList = [...this.fileList, ...uniqueNewFiles];
        this.validateFiles();
      }
    }
  }

  /**
   * Удаление файла
   */
  removeFile(index: number) {
    this.fileList.splice(index, 1);
    this.fileList = [...this.fileList];
    this.validateFiles();
  }

  removeFileByFileName(fileName: string) {
    const index = this.fileList.findIndex(file => file.name === fileName);
    if (index !== -1) {
      this.removeFile(index);
    }
  }

  /**
   * Обновление валидности всех файлов
   */
  updateFilesValidity() {
    this.filesValid = this.fileList.length <= this.getAppealsAvailableCount();
  }

  /**
   * Валидация файлов
   */
  validateFiles(): boolean {
    this.fileError = "";
    const maxFiles = this.getAppealsAvailableCount();

    if (this.fileList.length > maxFiles) {
      this.fileError = `Прикреплено более ${maxFiles} файлов`;
      this.filesValid = false;
      return false;
    }

    for (const file of this.fileList) {
      const maxSize = this.getAppealsAcceptedFileSize() * 1024 * 1024;
      if (file.size > maxSize) {
        this.fileError = `Файл "${file.name}" превышает максимальный размер ${this.getAppealsAcceptedFileSize()} МБ`;
        this.filesValid = false;
        return false;
      }

      const allowedExtensions = this.getAppealsAcceptedExtensionsArr();
      const extension = file.name.toLowerCase().split('.').pop();
      if (!extension || !allowedExtensions.includes(extension)) {
        this.fileError = `Файл "${file.name}" имеет недопустимое расширение. Допустимы: ${allowedExtensions.join(', ')}`;
        this.filesValid = false;
        return false;
      }
    }

    this.filesValid = true;
    return true;
  }

  mounted() {
    this.siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY || "";
    this.recaptchaEnabled = (process.env.VUE_APP_RECAPTCHA_ENABLED || '') === "true";

    // список филиалов
    this.getBranches();
    if (this.branchesList.length <= 1) {
      this.values['branch'] = this.branchesListFormatted[0] != undefined ? (this.branchesListFormatted[0] || "") : "";
    }
    // конфиг
    this.getConfig();
  }

  public onCaptchaExpired() {
    //@ts-ignore
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.reset()
    }
  }

  public validate() {
    if (this.recaptchaEnabled) {
      this.$refs.recaptcha.execute()
    } else {
      this.submitForm('')
    }
  }

  submitForm(recaptchaToken: string) {
    this.submitError = "";
    this.submitSuccess = "";
    this.useSubmitButtonLoading = true;

    this.hasFileErrors = false;
    this.fileError = "";

    // Валидация файлов перед отправкой
    if (!this.validateFiles()) {
      this.useSubmitButtonLoading = false;
      this.hasFileErrors = true;
      return;
    }

    const formData = new FormData();

    // Добавляем основные поля (кроме file)
    for (let key in this.values) {
      if (key === 'branch') {
        formData.append(key, this.branchID);
      } else if (key !== 'file' && key !== 'allowDataHandling') { // Исключаем file
        formData.append(key, this.values[key]);
      }
    }

    // Добавляем чекбокс отдельно
    formData.append('allowDataHandling', String(this.values['allowDataHandling']));

    // Добавляем файлы из fileList
    if (this.fileList.length > 0) {
      for (let file of this.fileList) {
        formData.append("file[]", file);
      }
    }

    formData.append('recaptchaToken', recaptchaToken);

    this.techSupportSend(formData)
      .then((_) => {
        this.submitSuccess = "Обращение создано";
      })
      .catch((e) => {
        this.submitError = e;
      })
      .finally(() => {
        this.useSubmitButtonLoading = false;
      });
  }

  /**
   * Скачивание файла согласия на обработку персональных данных
   */
  public downloadPdFile(): void {
    const { downloadPdDocument, downloadDocument } = this;

    this.downloadButtonLoading = true;

    downloadPdDocument(this.branchID || "")
      .then((response: AxiosResponse) => {
        downloadDocument(response);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.downloadButtonLoading = false;
      });
  }
}

export default TechnicalSupport;
